import { render } from "./SizeFilterDropdown.vue?vue&type=template&id=728ce81e"
import script from "./SizeFilterDropdown.vue?vue&type=script&lang=js"
export * from "./SizeFilterDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__